// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"css3"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 2H21L20 19.5L12 22.5L4 19.5L3 2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 2H21L20 19.5L12 22.5L4 19.5L3 2Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M7.26589 15.4094L7.24779 15.0734H7.24969L7.26589 15.4094ZM7.26589 15.4094L7.3427 16.7536L11.9997 18.5L16.6566 16.7537L16.9638 11.3768L7.03546 11.3768L7.02192 11.14L17.2574 6.24001L17.2711 6H11.9997M11.9997 6L6.62338 6.00999L6.62207 6H11.9997Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-css3')
export default class Css3Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'css3',
    }
  }
}
